import React, { Component } from "react";
import { Fade } from "react-reveal";
import { servicesData } from "../../portfolio.js";
import { useLanguage } from "../../context/LanguageContext";
import { getTranslation } from "../../translations/translations";
import "./ServicesSection.css";

// Service day label keys mapping
const dayKeyMap = {
  "Weekly Liturgy": "service_day_weekly",
  "Weekday Prayer": "service_day_prayer",
  Children: "service_day_children",
  "Bible Study": "service_day_bible",
  Community: "service_day_community",
};

// Service time keys mapping
const timeKeyMap = {
  Sundays: "sundays",
  Saturdays: "saturdays",
  "As Announced": "as_announced",
  Regularly: "regularly",
  Ongoing: "ongoing",
};

// Service name keys mapping
const serviceKeyMap = {
  "Weekly Liturgy (Kidase)": "weekly_liturgy",
  "Prayer & Fellowship": "prayer_fellowship",
  "Saturday School for Children": "sunday_school",
  "Bible Study & Spiritual Teaching": "bible_study",
  "Community Support and Cultural Programs": "community_support",
};

// Service details keys mapping
const detailsKeyMap = {
  "Weekly Liturgy (Kidase)": "weekly_liturgy_details",
  "Prayer & Fellowship": "prayer_fellowship_details",
  "Saturday School for Children": "sunday_school_details",
  "Bible Study & Spiritual Teaching": "bible_study_details",
  "Community Support and Cultural Programs": "community_support_details",
};

function ServicesSectionContent({ language, theme }) {
  return (
    <div className="services-main">
      <div className="services-header">
        <Fade bottom duration={1000} distance="40px">
          <h1 className="services-heading" style={{ color: theme.text }}>
            {getTranslation(language, "worship_services")}
          </h1>
          <p
            className="services-subtitle"
            style={{ color: theme.secondaryText }}
          >
            {getTranslation(language, "worship_services_desc")}
          </p>
        </Fade>
      </div>

      <div className="services-list">
        {servicesData.services.map((service, index) => (
          <Fade key={index} bottom duration={1500} distance="40px">
            <div className="service-card">
              <div
                className="service-day"
                style={{ backgroundColor: theme.highlight, color: theme.body }}
              >
                {getTranslation(
                  language,
                  dayKeyMap[service.day] || "service_day_weekly"
                )}
              </div>
              <div className="service-content">
                <h3 style={{ color: theme.text }}>
                  {getTranslation(
                    language,
                    serviceKeyMap[service.service] || "weekly_liturgy"
                  )}
                </h3>
                <p
                  className="service-time"
                  style={{ color: theme.secondaryText }}
                >
                  🕐{" "}
                  {getTranslation(
                    language,
                    timeKeyMap[service.time] || "sundays"
                  )}
                </p>
                <p
                  className="service-details"
                  style={{ color: theme.textColor }}
                >
                  {getTranslation(
                    language,
                    detailsKeyMap[service.service] || "weekly_liturgy_details"
                  )}
                </p>
              </div>
            </div>
          </Fade>
        ))}
      </div>
    </div>
  );
}

class ServicesSection extends Component {
  render() {
    const theme = this.props.theme;
    const language = this.props.language;
    return <ServicesSectionContent theme={theme} language={language} />;
  }
}

// Wrapper component to inject language from context
function ServicesSectionWithLanguage(props) {
  const { language } = useLanguage();
  return <ServicesSection {...props} language={language} />;
}

export default ServicesSectionWithLanguage;
